import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/app/products/grocery/components/GroceryContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Header.tsx");
